module.exports = __webpack_public_path__ + "static/img/2dbg.da6aea06.png";